import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_MARKETABLE_AMENITY,
  FETCH_MARKETABLE_AMENITY_SUCCESS,
  FETCH_MARKETABLE_AMENITY_FAILURE,
] = createRequestConstantNames(cc('FETCH_MARKETABLE_AMENITY'));
